module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"search":"Поиск"},"en":{"search":"Search"}}')
  delete Component.options._Ctor
}
